import {ConfirmationService} from './confirmation.service';
import {Injectable} from '@angular/core';

@Injectable()
export class BrowserConfirmationService extends ConfirmationService {
  showConfirmation(message: string): boolean {
    return window.confirm(message);
  }
}
